import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class Loading extends Component {

	static propTypes = {
		show: PropTypes.bool
	};

	render() {
		return this.props.show ? (
			<div className="fixed-plugin loading-icon-wrapper">
				<i className="fa fa-refresh fa-2x"/>
			</div>
		) : '';
	}
}


// WEBPACK FOOTER //
// ./React/src/components/main/Loading.js